<template>
  <div class="ma-2">
    <v-card flat rounded outlined class="cardOutline my-2" :loading="loading">
      <div class="d-flex flex-column py-2 px-4">
        <div
          class="d-flex flex-row flex-wrap align-center justify-center justify-sm-start"
        >
          <div class="text-h4">Private Label Browser</div>
          <v-spacer class="d-sm-inline-flex d-none"></v-spacer>
          <v-btn-toggle
            v-model="groupByBrand"
            rounded
            class="my-2 my-sm-1"
            active-class="orangeActive
"
          >
            <v-btn small :value="null" @click="briefLoading()"
              ><v-icon small class="mr-2">mdi-format-list-bulleted</v-icon>List
            </v-btn>
            <v-btn small value="name_brand" @click="briefLoading()"
              ><v-icon small class="mr-2">mdi-format-list-text</v-icon>Group by
              Brand</v-btn
            >
          </v-btn-toggle>
          <!-- <v-checkbox
            v-model="groupByBrand"
            hide-details
            label="Group By Brand"
            value="name_brand"
          ></v-checkbox> -->
        </div>
        <v-card-text class="pa-2">
          <div
            class="d-flex flex-column flex-sm-row flex-wrap align-sm-center justify-center justify-sm-start"
          >
            <div class="mr-3 overline">Filters</div>
            <div :class="$vuetify.breakpoint.smAndUp ? 'mdSelect' : ''">
              <v-text-field
                class="compact-select"
                flat
                hide-details="auto"
                outlined
                rounded
                dense
                background-color="#FFF"
                v-model="filters.name"
                label="Name"
                clearable
              ></v-text-field>
            </div>
            <div
              v-for="(filter, i) in filterSelects"
              :key="i"
              :class="$vuetify.breakpoint.smAndUp ? filter.class : ''"
            >
              <v-select
                v-if="meta && meta[filter.key]"
                v-model="filters[filter.key]"
                :items="getFilterOptions(filter.key)"
                :label="filter.label"
                item-text="text"
                item-value="value"
                outlined
                rounded
                flat
                dense
                hide-details
                clearable
                background-color="#FFF"
                class="compact-select white"
              >
                <template slot="label">
                  <span v-html="filter.label"></span>
                </template>
              </v-select>
            </div>
          </div>
          <!-- {{ filterOptions }} -->
        </v-card-text>
      </div>
    </v-card>

    <div class="caption d-flex flex-row flex-wrap mx-4 align-center my-2">
      <div class="overline mr-2 d-none d-sm-flex">Current filters:</div>
      <v-fade-transition>
        <div
          v-if="dirtyFilter"
          class="d-none d-sm-flex flex-row flex-wrap align-center"
        >
          <div>
            <v-btn
              x-small
              rounded
              outlined
              class="mr-2"
              @click="setFilterToDefault('name')"
              v-if="filters.name"
              color="grey darken-2"
              >Name contains '{{ filters.name }}'
              <v-icon x-small>mdi-close</v-icon></v-btn
            >
          </div>
          <div v-for="(item, i) in filterSelects" :key="i">
            <v-btn
              v-if="filters[item.key]"
              class="mr-2"
              x-small
              rounded
              outlined
              color="grey darken-2"
              @click="setFilterToDefault(item.key)"
            >
              <span v-html="item.label"></span>:
              {{ humanize(filters[item.key]) }}
              <v-icon x-small>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-btn
            x-small
            color="red"
            text
            @click="resetFilters()"
            v-if="dirtyFilter > 1"
            ><v-icon x-small class="mr-1">mdi-close-circle-outline</v-icon>
            Clear All</v-btn
          >
        </div>
        <div v-else class="d-none d-sm-flex">None</div>
      </v-fade-transition>
      <v-spacer></v-spacer>
      <v-btn
        rounded
        outlined
        x-small
        @click="expand_collapse()"
        color="primary"
        v-if="groupByBrand"
      >
        {{ doExpand ? "Expand All" : "Collapse All" }}
        <v-icon x-small class="ml-1"
          >{{ doExpand ? "mdi-arrow-expand" : "mdi-arrow-collapse" }}
        </v-icon>
      </v-btn>
    </div>

    <!-- <v-btn @click="expand_collapse()">Expand</v-btn> -->

    <div v-if="filteredLenses">
      <!-- <div v-for="(group, i) in lensesForOrderBy" :key="i">
        {{ lens.name_private }} ({{ lens.name_brand }})
      </div> -->
      <v-data-table
        :items="filteredLenses"
        :headers="headersForSize"
        hide-default-footer
        disable-pagination
        sort-by="name_private"
        :group-by="groupByBrand"
        :hide-default-header="!$vuetify.breakpoint.smAndUp"
        @click:row="handleClick"
        class="pointer"
      >
        <template
          v-slot:group.header="{ group, items, isOpen, toggle, isMobile }"
        >
          <td
            :colspan="headersForSize.length"
            :class="{ 'groupHeader v-data-table__mobile-row': isMobile }"
            style="background-color: rgb(244 250 255); min-height: 55px"
            @click="toggle"
            v-if="groupByBrand"
          >
            <div
              class="d-flex flex-row align-center pointer"
              style="width: 100%"
            >
              <div :class="isMobile ? 'brandImgDiv_mobile' : 'brandImgDiv'">
                <product-image
                  type="scl"
                  :fileString="
                    items[0].image_brand ? items[0].image_brand : 'generic.svg'
                  "
                  :maxHeight="40"
                  :maxWidth="isMobile ? 90 : 150"
                  class="my-2"
                  :eager="true"
                  position="left center"
                  :lazySrc="CL_IMAGE_DIR + 'generic.svg'"
                />
              </div>
              <div
                class="mx-3 flex-grow"
                :style="isMobile ? '' : 'min-width: 250px'"
                :class="isMobile ? 'font-weight-bold' : 'title'"
              >
                {{ items[0].name_brand }}
              </div>

              <v-spacer class=""></v-spacer>
              <v-btn
                text
                icon
                small
                color="primary"
                class="ma-1"
                :ref="group"
                :data-open="isOpen"
              >
                <v-icon>{{
                  isOpen ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </div>
          </td>
        </template>
        <template v-slot:group.summary="{ isOpen }">
          <div v-if="isOpen" class="summarySpacer">&nbsp;</div>
        </template>
        <template v-slot:item.image_private="{ item }">
          <div class="imageCell">
            <!-- <v-img
              :src="CL_IMAGE_DIR + '/' + item.image_private"
              max-width="100"
              max-height="40"
              contain
              class="ma-1"
            ></v-img> -->

            <product-image
              type="scl"
              :fileString="
                item.image_private ? item.image_private : 'generic.svg'
              "
              :maxHeight="40"
              :maxWidth="100"
              class="ma-1"
              position="center center"
              :lazySrc="CL_IMAGE_DIR + 'generic.svg'"
            />
          </div>
        </template>

        <template v-slot:item.name_private="{ item }">
          <div class="font-weight-bold">{{ item.name_private }}</div>
          <!-- <div class="caption" v-if="!groupByBrand">{{ item.name_brand }}</div> -->
        </template>
        <template v-slot:item.type_tag="{ item }">
          <soft-type-icon
            :lens="item"
            type="type"
            labelClass="ml-2 caption"
          ></soft-type-icon>
          <!-- :showLabel="true"
 -->
        </template>
        <template v-slot:item.h2o="{ item }">
          <div v-if="item.h2o">{{ item.h2o }}%</div>
        </template>

        <template v-slot:item.mobile="{ item }">
          <div class="d-flex flex-row my-2 align-center">
            <div>
              <div style="width: 110px">
                <!-- <v-img
                  v-if="item.image_private"
                  :src="CL_IMAGE_DIR + '/' + item.image_private"
                  width="80"
                  contain
                ></v-img> -->
                <product-image
                  type="scl"
                  :fileString="
                    item.image_private ? item.image_private : 'generic.svg'
                  "
                  :maxHeight="60"
                  :maxWidth="80"
                  position="center center"
                  :lazySrc="CL_IMAGE_DIR + 'generic.svg'"
                />
              </div>
            </div>
            <div class="text-left">
              <div class="d-flex flex-row flex-wrap">
                <div class="font-weight-bold mr-2">
                  {{ item.name_private }}
                </div>
                <div class="caption">({{ item.name_brand }})</div>
              </div>

              <div class="d-flex flex-row flex-wrap">
                <div class="mr-3">
                  <span class="">BC:</span> {{ item.basecurves }}
                </div>
                <div><span class="">Diam.:</span> {{ item.diameters }}</div>
              </div>
              <div class="d-flex flex-row flex-wrap">
                <div class="mr-3">{{ item.polymer }}</div>
                <div v-if="item.h2o">{{ item.h2o }}% H<sub>2</sub>O</div>
              </div>
            </div>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import HardLinksMixin from "@/assets/js/HardLinksMixin.js";
import SoftTypeIcon from "@/components/clStuff/SoftTypeIcon.vue";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
// import ProductImage from "@/components/clStuff/ProductImage";

export default {
  name: "PrivateLabels",
  components: {
    SoftTypeIcon,
    ProductImage: () => import("@/components/clStuff/ProductImage"),
  },
  mixins: [HardLinksMixin, FiltersMixin],
  props: {},
  data: function () {
    return {
      lenses: null,
      meta: null,
      loading: false,
      orderBy: "privates",
      groupByBrand: null,
      // nameFilter: null,
      doExpand: false,
      filterSelects: [
        { label: "Type", key: "types", class: "mdSelect" },
        { label: "BC", key: "bcs", class: "smSelect" },
        { label: "Diam", key: "diameters", class: "smSelect" },
        { label: "H<sub>2</sub>O", key: "h2os", class: "smSelect" },
        { label: "Polymers", key: "polymers", class: "mdSelect" },
      ],
      filterDefaults: {
        polymers: null,
        bcs: null,
        diameters: null,
        h2os: null,
        types: null,
        name: "",
      },
      filters: null,
      headers: [
        { text: "", value: "image_private", sortable: false },
        { text: "Private Label", value: "name_private", sortable: true },
        { text: "Brand", value: "name_brand", sortable: true },

        { text: "Type", value: "type_tag", sortable: true },
        { text: "Polymer", value: "polymer", sortable: true },
        { text: "H2O", value: "h2o", sortable: true },
        { text: "BC", value: "basecurves", sortable: true },
        { text: "Diam", value: "diameters", sortable: true },
      ],
      headersForMobile: [{ text: "", value: "mobile", sortable: false }],
    };
  },
  methods: {
    getData() {
      this.loading = true;

      ApiServices.genericApiCall("/lens/privateLabels")
        .then((response) => {
          this.lenses = response.data.lenses;
          this.meta = response.data.meta;
          //this.companiesLoaded = this.selectedCompanyIds;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e); // todo - display it
        });
    },
    humanize(str) {
      var i,
        frags = str.split("_");
      for (i = 0; i < frags.length; i++) {
        frags[i] =
          frags[i].charAt(0).toUpperCase() + frags[i].substr(1).toLowerCase();
      }
      return frags.join(" ");
    },

    handleClick(value) {
      let identifier = value.slug ? value.slug : value.id_brand;
      let url = "/cls/details/" + identifier;
      url += "#privateId=" + value.id_private;
      this.$router.push({
        path: url,
      });
    },

    getFilterOptions(key) {
      //   if (!this.meta || this.meta[key]) return null;
      //   console.log("key", key);
      let options = Object.keys(this.meta[key]);
      //   console.log("options", options);
      let rtn = [];
      options.forEach((option) => {
        let obj = { value: option, text: option };
        if (key == "types") obj.text = this.humanize(option) + "s";
        if (key == "h2os") obj.text = option + "%";
        rtn.push(obj);
      });

      return rtn;
    },
    // clearFilters() {
    //   this.filters = { ...this.filterDefaults };
    // },
    expand_collapse() {
      this.doExpand ? this.openAll() : this.closeAll();
      this.doExpand = !this.doExpand;
    },
    closeAll() {
      Object.keys(this.$refs).forEach((k) => {
        // console.log(this.$refs[k]);
        if (this.$refs[k] && this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    openAll() {
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && !this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    briefLoading(time = 1500) {
      const that = this;
      that.loading = true;
      setTimeout(function () {
        that.loading = false;
      }, time);
    },
  },
  computed: {
    headersForSize: function () {
      return this.$vuetify.breakpoint.smAndUp
        ? this.headers
        : this.headersForMobile;
    },

    filterSummary: function () {
      if (!this.dirtyFilter) return null;
      let rtnArr = [];
      let keys = Object.keys(this.filters);
      keys.forEach((key) => {
        let val = this.filters[key];
        if (val != null) rtnArr.push(`${key}: ${this.humanize(val)}`);
      });
      return rtnArr.join(", ");
    },

    filteredLenses: function () {
      // console.log("check'n filtas");
      if (!this.meta) return null;
      //   let rtn = this.lenses;
      let m = this.meta;
      let f = this.filters;
      let f_type = f.types;
      let f_bcArr = f.bcs ? m.bcs[f.bcs] : null;
      let f_diameterArr = f.diameters ? m.diameters[f.diameters] : null;
      let f_h2oArr = f.h2os ? m.h2os[f.h2os] : null;
      let f_polymerArr = f.polymers ? m.polymers[f.polymers] : null;
      let f_name = this.filters.name;

      let filtered = this.lenses.filter((lens) => {
        let p_id = lens.id_private;

        // -------- by name
        if (f_name && f_name != "") {
          f_name = f_name.toLowerCase();
          let brandMatch = lens.name_brand.toLowerCase().includes(f_name);
          let privateMatch = lens.name_private.toLowerCase().includes(f_name);
          // console.log(lens.name_brand, f_name);
          if (!brandMatch && !privateMatch) return false;
        }
        // ------ by type
        if (f_type && f_type != lens.type_tag) return false;
        // ------ by bc & diameter & polymer
        if (f_bcArr && !f_bcArr.includes(p_id)) return false;
        if (f_diameterArr && !f_diameterArr.includes(p_id)) return false;
        if (f_h2oArr && !f_h2oArr.includes(p_id)) return false;
        if (f_polymerArr && !f_polymerArr.includes(p_id)) return false;

        return true;
      });
      return filtered;
    },
  },
  watch: {
    filters: {
      handler() {
        this.briefLoading(500);
      },
      deep: true,
    },
  },
  created: function () {
    this.filters = { ...this.filterDefaults };
  },
  mounted: function () {
    this.getData();
    this.setFiltersFromHash();
  },
  metaInfo() {
    return {
      title: "EyeDock/CLs | Private Label Browser",
    };
  },
};
</script>

<style scoped>
/* .groupHeader {
  padding: 0 !important;
  min-height: 54px;
} */
.headerDiv {
  padding: 5px;
  /* border-radius: 3px; */
  /* background-color: #f5fafe;
  border: 1px solid #c7ddf9; */
  /* background-color: #ffe6ce; */
  /* border-radius: 50vh; */
  /* margin-bottom: -1px; */
  padding-left: 1.5em;
  min-height: 54px;
}
/* .topSpacer {
  margin-top: 2em;
} */
.brandImgDiv {
  width: 160px;
}
.brandImgDiv_mobile {
  width: 100px;
}
.sortable,
.v-data-table-header {
  vertical-align: top;
}
.smSelect {
  width: 160px;
}
.mdSelect {
  width: 200px;
}
.summarySpacer {
  background: #fff;
  height: 2em;
}
.cardOutline {
  border: 1px solid #b6c4c8 !important;
  background-color: #e3f2fd;
}
.imageCell {
  width: 120px;
}
</style>
